import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';

const SubscriptionRoute = () => {
    const { user, auth } = useAuth();
    const [isLoading, setIsLoading] = useState(true);
    const [hasSubscription, setHasSubscription] = useState(false);

    useEffect(() => {
        const checkSubscription = async () => {
            if (!user) {
                setIsLoading(false);
                return;
            }
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/payments/subscription`);
                if (response.ok) {
                    const data = await response.json();
                    setHasSubscription(!!data.subscription);
                } else {
                    setHasSubscription(false);
                }
            } catch (error) {
                console.error('Failed to check subscription:', error);
                setHasSubscription(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkSubscription();
    }, [user, auth]);

    if (!user) {
        return <Navigate to="/sign-in" replace />;
    }

    if (isLoading) {
        // You can replace this with a proper loading spinner component
        return <div className="p-4 text-center">Loading subscription status...</div>;
    }

    if (!hasSubscription) {
        // Redirect to pricing page if no subscription
        return <Navigate to="/pricing" replace />;
    }

    return <Outlet />;
};

export default SubscriptionRoute;
